import { render } from "./CategorySection.vue?vue&type=template&id=0404cc0b&scoped=true"
import script from "./CategorySection.vue?vue&type=script&lang=js"
export * from "./CategorySection.vue?vue&type=script&lang=js"

import "./CategorySection.vue?vue&type=style&index=0&id=0404cc0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0404cc0b"]])

export default __exports__